<template>
  <div v-if="(Object.keys(object).length !== 0 && object.constructor === Object)">
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              <h1 class="mt-0 mb-0">
                {{ object.name }}
              </h1>
            </b-col>
            <b-col
              cols="auto"
              class="text-right"
            />
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-tabs>
          <b-tab
            active
            title="Object Details"
          >
            <object-details
              class="mt-2"
              :object="object"
              :devices="devices"
              :sites="workspaceSites"
              @saveObjectDetails="saveObjectDetails"
            />
            <object-properties
              :object="object"
            />
            <object-devices
              :object="object"
              :devices="devices"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { API } from 'aws-amplify'
import {
  BTabs,
  BTab,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'

import { datadogLogs } from '@datadog/browser-logs'
import * as queries from '../../../graphql/queries'
import * as mutations from '../../../graphql/mutations'
import ObjectDetails from './ObjectDetails.vue'
import ObjectProperties from './ObjectProperties.vue'
import ObjectDevices from './ObjectDevices.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BRow,
    BCol,
    ObjectDetails,
    ObjectProperties,
    ObjectDevices,

  },
  data() {
    return {
      object: {},
      devices: [],
      sensorData: [],
      workspaceSites: [],
    }
  },
  created() {
    this.getObject()
    this.getWorkspaceSites()
  },
  methods: {
    // --- FUNCTIONS ---
    async getObject() {
      await API.graphql({
        query: queries.getObject,
        variables: {
          id: this.$route.params.id,
        },
      }).then(response => {
        if (!response.errors) {
          this.object = response.data.getObject
          this.listDevices(this.$route.params.id)
        }
      })
    },
    async listDevices(objectId) {
      await API.graphql({
        query: queries.listDevices,
        variables: {
          filter: {
            objectDevicesId: { eq: objectId },
          },
        },
      }).then(response => {
        if (!response.errors) {
          this.devices = response.data.listDevices.items
        }
      })
    },
    async getWorkspaceSites() {
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: JSON.parse(localStorage.getItem('workspace')).id,
        },
      }).then(response => {
        if (!response.errors) {
          this.workspaceSites = response.data.getWorkspace.sites.items
        }
      })
    },
    async saveObjectDetails(object) {
      await API.graphql({
        query: mutations.updateObject,
        variables: {
          input: {
            id: object.id,
            name: object.name,
            manufacturer: object.manufacturer,
            model: object.model,
            modelNumber: object.modelNumber,
            manufacturerSerialNumber: object.manufacturerSerialNumber,
            siteObjectsId: object.site.id,
          },
        },
      }).then(response => {
        if (!response.errors) {
          this.object = response.data.updateObject
        } else {
          datadogLogs.logger.error('Error updating object', {
            error: response.errors,
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/pages/page-profile.scss';
kbd {
  color: #3e3434
}

</style>
